import AppRecord from './AppRecord.js'
import APP from '../../../main.js'
class LossWarningNotification extends AppRecord {
  get recipant(){
    return this.constructor.employeeStore.users.find(usr => usr.id === this.recipant_id)||{}
  }
  get recipant_name(){
    if(this.recipant.person){
      return this.recipant.person.name
    } else {
      return null
    }
  }

  get recipant_type(){
    if(this.recipant.person){
      return this.recipant.person.translated_type
    } else {
      return null
    }
  }

  get respondant(){
    return this.constructor.employeeStore.users.find(usr => usr.id === this.respondant_id)||{}
  }
  get respondant_name(){
    if(this.respondant.person){
      return this.respondant.person.name
    } else {
      return null
    }
  }
  get sent_days_ago_string(){
    if(this.sent_at){
      let cre = Date.parse(this.sent_at)
      let now = Date.now()
      return this.daysAgoToString((now-cre)/1000/60/60/24)
    } else {
      return null
    }
  }
  get scheduled_days_ago_string(){
    let cre = Date.parse(this.scheduled_at)
    let now = Date.now()
    return this.daysAgoToString((now-cre)/1000/60/60/24)
  }
}
export default LossWarningNotification
